**Deprecated:** Use `interval` instead.
